export default function Homepage() {
  return (
    <section className="homepage">
      <div className="hero">
        {/* Text on left */}
        <div className="hero-text">
          <h1>Dr. Nirajan Bhandari</h1>
          <p>Professional Medical Care You Can Trust</p>
          <a href="#about" className="btn">Learn More</a>
        </div>

        {/* Doctor photo on right */}
        <div className="hero-image">
          <img src="/image.jpg" alt="Dr. Nirajan Bhandari" />

        </div>
      </div>

      {/* CSS */}
      <style>{`
        .homepage {
          min-height: 100vh;
          width: 100%;
          background-image: url('https://img.freepik.com/premium-photo/warm-cosmic-purple-abstract-creative-background-design_851755-250107.jpg?semt=ais_hybrid&w=740&q=80');
          background-size: cover;
          background-position: center;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .hero {
          display: flex;
          align-items: center;
          justify-content: space-between;
          max-width: 1200px;
          width: 90%;
          padding: 40px;
          border-radius: 12px;
          flex-wrap: wrap;
          gap: 40px;
        }

        /* Text */
        .hero-text {
          flex: 1 1 400px;
          text-align: left;
          animation: slideIn 1s ease-out;
        }

        .hero-text h1 {
          font-size: 48px;
          color: #5D3FD3;
          margin-bottom: 16px;
        }

        .hero-text p {
          font-size: 20px;
          color: #fff;
          margin-bottom: 24px;
        }

        .btn {
          background: #5D3FD3;
          color: white;
          padding: 12px 24px;
          border-radius: 6px;
          text-decoration: none;
          font-weight: 500;
          transition: background 0.3s;
        }

        .btn:hover {
          background: #4a33b0;
        }

        /* Doctor Image */
        .hero-image {
          flex: 0 0 250px;
          animation: fadeIn 1.5s ease-out;
        }

        .hero-image img {
          width: 250px;
          border-radius: 50%;
          border: 4px solid #5D3FD3;
          transition: transform 0.5s ease, box-shadow 0.5s ease;
        }

        .hero-image img:hover {
          transform: scale(1.05);
          box-shadow: 0 10px 20px rgba(0,0,0,0);
        }

        /* Animations */
        @keyframes slideIn {
          from { opacity: 0; transform: translateX(-50px); }
          to { opacity: 1; transform: translateX(0); }
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        /* Responsive */
        @media (max-width: 768px) {
          .hero {
            flex-direction: column-reverse;
            text-align: center;
          }

          .hero-text {
            text-align: center;
          }

          .hero-image img {
            width: 200px;
          }
        }
      `}</style>
    </section>
  );
}
